import React from 'react';

import { Discount } from '../discount';

const NewHomeDiscount = ({ ...discount }) => {
  // Don't pass onAdd handler - this prevents the "+" button from showing
  // The tooltip will still display via the description prop
  return <Discount {...discount} />;
};

export default NewHomeDiscount;
